/** Account identifiers remain unchanged for lookups; only presentation uses this label. */
export function getUserDisplayName(
  user: { nickname?: string | null; username?: string | null } | null | undefined,
  fallback = "사용자",
): string {
  return user?.nickname?.trim() || user?.username?.trim() || fallback;
}

/** Older system notifications stored the sender's handle in their leading byline. */
export function getNotificationDisplayMessage(
  message: string,
  sender: { nickname?: string | null; username?: string | null } | null,
): string {
  const nickname = sender?.nickname?.trim();
  if (!nickname || !sender?.username) return message;
  for (const prefix of [`@${sender.username}님`, `${sender.username}님`]) {
    if (message.startsWith(prefix)) return `${nickname}님${message.slice(prefix.length)}`;
  }
  return message;
}
